const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Modal } from 'react-bootstrap';

const _ = {
    find:       require('lodash/find'),
    findIndex:  require('lodash/findIndex'),
    forEach:    require('lodash/forEach'),
    filter:     require('lodash/filter'),
    includes:   require('lodash/includes'),
    map:        require('lodash/map'),
};

const Strings = require('../../../../app/shared/Strings');
// const Globals = require('../../../../app/globals');
const ShortCourseConstants =        require('../../../../app/shared/ShortCourseConstants');

//const ShortCourseActions =          require('../../actions/ShortCourseActions');
const ShortCourseEditorActions =    require('../../actions/ShortCourseEditorActions');
const ShortCourseEditorStore =      require('../../stores/ShortCourseEditorStore');

const ForgeError = require('../../util/error');
const AssetUtil = require('../../util/asset');

import ErrorBox from '../common/ErrorBox';
import ControlledInput from '../common/ControlledInput';
import LoadingSpinner from '../loading/LoadingSpinner';
import AccessibleIcon from '../common/AccessibleIcon';
import SingleAssetInput from '../common/SingleAssetInput';
import ConfirmModal from '../modal/ConfirmModal';
const GotoCommentIcon = require('./sidebar/GotoCommentIcon');
import CoachScriptActionEditor from './CoachScriptActionEditor';

const propTypes = {
    doc: PropTypes.object.isRequired,
    coachScriptId: PropTypes.string.isRequired,
    onEditCoachText: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
};

const defaultProps = {
};

function UnusedRichText({richTextEntry,doEdit,doDelete}) {
    return (
        <div className="unused-coach-rich-text">
            <label>{richTextEntry.displayName}</label>
            <button title="view/edit" onClick={doEdit}>
                <AccessibleIcon className="fa fa-pencil" label="view/edit"/>
            </button>
            <button title="delete" onClick={doDelete}>
                <AccessibleIcon className="fa fa-trash" label="delete"/>
            </button>
        </div>
    );
}

class EditCoachScriptModal extends React.Component {
    constructor(props) {
        super(props);
        let storeState = this.getStoreState(props);
        this.state = {
            ...storeState,
            error: null,
            expandedConditionIndex: -1, // valid action index if expanded
        };
        this.unsubscribes = [ShortCourseEditorStore.listen(this.onStoreChange)];
    }
 
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    onStoreChange=(/*storeState*/)=>{
        this.setState(this.getStoreState(this.props));
    }
    
    getStoreState=(props)=>{
        const scriptEntry = _.find(props.doc.client_content.coach_scripts,{id:props.coachScriptId});
        const richTextList = _.filter(props.doc.client_content.rich_texts,(entry)=>{
            if (!entry.coach_script_id) {
                return true; // common coach rich text entry
            }
            if (entry.coach_script_id === props.coachScriptId) {
                return true;
            }
            return false;
        });
        const stickerList = _.filter(props.doc.client_content.coach_stickers,(entry)=>(entry.specialPurpose ? false : true));
        let unusedRichTextList = [];
        let usedMap = {};
        _.forEach(scriptEntry.actions,(entry)=>{
            usedMap[entry.rich_text_id] = true;
        });
        _.forEach(richTextList,(entry)=>{
            if (entry.coach_script_id && !usedMap[entry.id]) {
                unusedRichTextList.push(entry);
            }
        });
        return {scriptEntry,richTextList,stickerList,unusedRichTextList};
    }

    updateAction=(actionIndex,changes)=>{
        if (changes.rich_text_id === 'add') {
            changes.rich_text_id = 'rt-' + uuid.v4();
            ShortCourseEditorActions.addCoachRichText(uuid.v4(),this.props.coachScriptId, changes.rich_text_id);
            setTimeout(()=>{
                ShortCourseEditorActions.updateCoachScriptAction(uuid.v4(),this.props.coachScriptId,actionIndex,changes);
            },10)
            return;
        }
        ShortCourseEditorActions.updateCoachScriptAction(uuid.v4(),this.props.coachScriptId,actionIndex,changes);
    }
    
    /*addRichText=()=>{
        let coach_script_id = this.props.coachScriptId;
        ShortCourseEditorActions.addCoachRichText(uuid.v4(),coach_script_id);
    }*/

    editActionRichText=(coachAction)=>{
        let richTextQuery = {id:coachAction.rich_text_id};
        let richTextEntry = _.find(this.props.doc.client_content.rich_texts,richTextQuery);
        if (!richTextEntry) {
            console.log("No rich text with id ",coachAction.rich_text_id);
            return;
        }
        this.props.onEditCoachText(richTextQuery,richTextEntry.displayName);
    }
    
    editRichTextEntry=(richTextEntry)=>{
        let richTextQuery = {id: richTextEntry.id};
        this.props.onEditCoachText(richTextQuery,richTextEntry.displayName);
    }

    deleteRichTextEntry=(richTextEntry)=>{
        let questionText = `Are you sure you wish to delete rich text "${richTextEntry.displayName}" ?`;
        
        this.setState({
            modalConfirm: {
                modalTitle: "Confirm Delete",
                text: questionText,
                confirmHandler: ()=>{
                    this.setState({modalConfirm: null},()=>{
                        ShortCourseEditorActions.deleteCoachRichText(uuid.v4(),richTextEntry.id);
                    });
                },
                cancelHandler: ()=>{
                    this.setState({modalConfirm: null})
                },
            }
        });
    }

    toggleConditionEditor=(i)=>{
        if (this.state.expandedConditionIndex === i) {
            this.setState({expandedConditionIndex:-1});
        }
        else {
            this.setState({expandedConditionIndex:i});
        }
    }

    addAction=()=>{
        ShortCourseEditorActions.addCoachScriptAction(uuid.v4(),this.props.coachScriptId);
    }
    
    moveAction=(actionIndex,delta)=>{
        ShortCourseEditorActions.moveCoachScriptAction(uuid.v4(),this.props.coachScriptId,actionIndex,delta);
    }

    deleteAction=(actionIndex)=>{
        this.setState({
            modalConfirm: {
                modalTitle: "Confirm Delete",
                text: "Are you sure you wish to delete this action?",
                confirmHandler: ()=>{
                    this.setState({modalConfirm: null},()=>{
                        ShortCourseEditorActions.deleteCoachScriptAction(uuid.v4(),this.props.coachScriptId,actionIndex);
                    });
                },
                cancelHandler: ()=>{
                    this.setState({modalConfirm: null})
                },
            }
        });
    }

    render() {
        let {scriptEntry,richTextList,stickerList,unusedRichTextList} = this.state;
        const canDeleteAction = (scriptEntry.actions.length > 1);
        
        let staticScriptEntry = _.find(ShortCourseConstants.COACH_SCRIPTS,{id:scriptEntry.id});
        let showAdditionalCheckbox = _.includes(staticScriptEntry.options,'showAdditionalRemedialSkills');
        let doChangeActivityElementsCheckbox = false; // (showActivityElements is no longer used) // _.includes(staticScriptEntry.options,'showActivityElements');
        
        let first_showAdditionalRemedialSkills = _.findIndex(scriptEntry.actions,(action)=>(!!action.showAdditionalRemedialSkills));
        let first_showActivityElements = false; // _.findIndex(scriptEntry.actions,(action)=>(!!action.showActivityElements));
        
        let actionElems = [];
        _.forEach(scriptEntry.actions,(coachAction,i)=>{
            const canMoveUp = (i>0);
            const canMoveDown = (i+1<scriptEntry.actions.length);
            const prior_showAdditionalRemedialSkills = ((first_showAdditionalRemedialSkills >=0) && (first_showAdditionalRemedialSkills < i));
            const prior_showActivityElements = ((first_showActivityElements >= 0) && (first_showActivityElements < i));
            
            actionElems.push (
                <CoachScriptActionEditor key={i} 
                    actionIndex={i}
                    coachAction={coachAction} 
                    richTextList={richTextList} 
                    stickerList={stickerList} 
                    doUpdate={ (changes)=>{this.updateAction(i,changes)} }
                    doEditCoachText={ ()=>{this.editActionRichText(coachAction)} }
                    doMoveUp={ canMoveUp ? ()=>{this.moveAction(i,-1)} : null }
                    doMoveDown={ canMoveDown ? ()=>{this.moveAction(i,1)} : null }
                    doDeleteAction={ canDeleteAction ? ()=>{this.deleteAction(i)} : null }
                    doChangeAdditionalCheckbox={showAdditionalCheckbox ? (e)=>{ this.updateAction(i,{showAdditionalRemedialSkills: e.target.checked}) } : null }
                    prior_showAdditionalRemedialSkills={prior_showAdditionalRemedialSkills}
                    doChangeActivityElementsCheckbox={doChangeActivityElementsCheckbox ? (e)=>{ this.updateAction(i,{showActivityElements: e.target.checked}) } : null }
                    prior_showActivityElements={prior_showActivityElements}
                    toggleConditionsEditor={()=>{this.toggleConditionEditor(i)}}
                    conditionsExpanded={(this.state.expandedConditionIndex === i)}
                    onChangeConditions={ (conditions)=>{ this.updateAction(i,{conditions})} }
                    />
            );
            if (staticScriptEntry.showCriteriaScores && (actionElems.length === 1)) {
                actionElems.push(
                    <div key={i+'-reportcard'} className="report-card-action-placeholder">
                        {Strings['en'].short_course.REPORT_CARD_ACTION_LINE}
                    </div>
                )
            }
        });
        
        if (this.state.modalConfirm) {
            let { modalTitle, text, confirmHandler, cancelHandler } = this.state.modalConfirm;
            return (
                <ConfirmModal key="confirmModal"
                    theme="new"
                    show={true}
                    modalTitle={modalTitle}
                    text={text}
                    buttonText={"confirm"}
                    confirmHandler={confirmHandler}
                    cancelButtonText={"cancel"}
                    cancelHandler={cancelHandler}
                    closeHandler={cancelHandler}
                    confirmButtonBsStyle="info"
                    cancelButtonBsStyle="info"
                    enforceFocus
                    restoreFocus
                    backdrop
                />
            );
        }
        
        
        return (
            <Modal key="mainModal"
                className={"short-course-coach-script-editor-modal" + (this.props.nonModal ? " modal-non-modal" : "")}
                show={true}
                keyboard
                autoFocus
                enforceFocus={false}
                restoreFocus={false}
                backdrop={false}
                animation={false}
                onHide={this.props.closeHandler}
                aria-labelledby="coach-script-editor"
            >
                <Modal.Header closeButton closeLabel={Strings['en'].common.CLOSE} onHide={this.props.closeHandler}>
                    <Modal.Title id="coach-script-editor">{`Coach Script for ${scriptEntry.displayName}`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="formlike coach-script-actions">
                        {actionElems}
                    </div>
                    <button className="add-coach-action-button" title="add action" onClick={this.addAction}>
                        <AccessibleIcon className="fa fa-plus" label="add coach action"/>
                        {'Add Coach Action'}
                    </button>
                    
                    {unusedRichTextList.length ? <hr/> : null }
                    {unusedRichTextList.length ? 
                    <div className="formlike unused-rich-text-entries">
                        <h1>{'Rich Text Entries not currently used in any of the above actions'}</h1>
                        {_.map(unusedRichTextList,(richTextEntry,i)=>(
                            <UnusedRichText key={i} 
                                richTextEntry={richTextEntry}
                                doEdit={()=>{
                                    this.editRichTextEntry(richTextEntry)
                                }}
                                doDelete={()=>{
                                    this.deleteRichTextEntry(richTextEntry)
                                }}
                            />
                        ))}
                    </div>
                    : null }
                    <ErrorBox error={this.state.error} />
                </Modal.Body>
                <Modal.Footer>
                    <GotoCommentIcon {...this.props.commentProps} navLoc={{type:ShortCourseConstants.NAV_TYPES.CoachScript,id: this.props.coachScriptId}} />
                </Modal.Footer>
            </Modal>
        );
    } // render
}; // EditCoachScriptModal

EditCoachScriptModal.propTypes = propTypes;
EditCoachScriptModal.defaultProps = defaultProps;

export default EditCoachScriptModal;